import styled from "styled-components";
import colours from "styles/colours";
import fonts from "styles/fonts";

export const StyledText = styled.p`
  font-size: ${fonts.smallMedium};
  color: ${colours.elexonBlack};
  border-radius: 4px 4px 0 0;
  letter-spacing: 0.4px;
`;

export const TabButton = styled.button<{
  isActive: boolean;
}>`
  all: unset;
  display: flex;
  justify-content: center;
  cursor: pointer;
  padding: 0 1rem;
  font-weight: 900;

  background: ${({ isActive }): string =>
    isActive ? colours.lightGrey : "inherit"};
  border: 1px solid transparent;
  border-bottom: ${({ isActive }): string =>
    isActive ? `2px solid ${colours.elexonBlack}` : "2px solid transparent"};

  &:hover:not([aria-selected="true"]) ${StyledText} {
      color: ${colours.elexonBlue};
    }
  }

  &&:focus-visible {
    border: 2px solid ${colours.elexonBlack};
    box-shadow: none;
  }
`;

export const StyledDiv = styled.div`
  all: unset;
  text-align: center;
  display: flex;
  align-items: center;
  min-height: 48px;
`;
